export default {
    SET_TIMEKIT_PROJECT_LIST: (state, { projectList }) => {
     
        state.projectList = projectList;
      },
}
